import { CommonModule } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { isPlatformBrowser } from "@angular/common";
import { assetsConst } from "src/app/core/const/assets.const";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/services/auth.service";
import { Subject, takeUntil } from "rxjs";

interface AdData {
  _id?: string;
  bannerType?: number;
  categoryId?: string;
  title?: string;
  title_ar?: string;
  description?: string;
  description_ar?: string;
  image?: string;
  appImage?: string;
  url?: string;
  isDeleted?: boolean;
  isBlocked?: boolean;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

@Component({
  selector: "megastore-welcome-popup",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: "./welcome-popup.component.html",
  styleUrls: ["./welcome-popup.component.scss"],
})
export class WelcomePopupComponent implements OnInit, OnDestroy {
  assetsConst = assetsConst;
  private platFormId = inject(PLATFORM_ID);
  private destroy$ = new Subject<boolean>();
  adData: AdData | null = null;
  displayTitle: string = "";
  displayDescription: string = "";
  displayImage: string = "";

  constructor(
    private dialogRef: MatDialogRef<WelcomePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AdData[] | null[],
    private translateService: TranslateService,
    private authService: AuthService
  ) {
    this.adData = data?.[0] || null;
  }

  ngOnInit(): void {
    if (this.adData) {
      this.updateContent();
    }

    // Subscribe to language changes
    this.authService.selectedLang
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.adData) {
          this.updateContent();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private updateContent(): void {
    if (!this.adData) {
      return;
    }

    const isArabic = this.translateService.currentLang === "ar";

    // Handle title
    this.displayTitle = isArabic
      ? this.adData.title_ar || this.adData.title || ""
      : this.adData.title || this.adData.title_ar || "";

    // Handle description
    this.displayDescription = isArabic
      ? this.adData.description_ar || this.adData.description || ""
      : this.adData.description || this.adData.description_ar || "";

    // Handle image - prefer appImage if available, otherwise use image
    this.displayImage = this.adData.appImage || this.adData.image || this.assetsConst.homeBanner;
    console.log("displayImage", this.displayImage,this.adData);
    console.log("displayTitle", this.displayTitle);
    console.log("displayDescription", this.displayDescription);
  }

  onAdClick(): void {
    if (this.adData?.url) {
      if (isPlatformBrowser(this.platFormId)) {
        window.open(this.adData.url, "_blank");
      }
    }
  }

  closeModal(): void {
    if (isPlatformBrowser(this.platFormId)) {
      localStorage.setItem("welcomePopupClosed", "true");
    }
    this.dialogRef.close();
  }
}

